module.exports = __webpack_public_path__ + "static/hospitaalbroeders-logo-white-bcdc8503e735f5c636033530742016fe.svg";